import React from 'react';
import './IndexThirdView.css';
import PropTypes from 'prop-types';
import { ButtonText } from '../ButtonSquare';
import PostPreview from '../PostPreview';
import TitleHeader from '../TitleHeader';

const IndexThirdView = (props) => {
  const {
    data: {
      edges: articles,
    },
  } = props;
  const postPreviewDivs = [];
  if (articles) {
    articles.forEach((element) => {
      const article = element.node;
      postPreviewDivs.push(<PostPreview
        pictureSrc={article.pictures[0].sizes}
        alt={article.pictures[0].alt}
        title={article.title}
        subtitle={article.subtitle}
        link={`/${article.slug}`}
        theme="dark"
      />);
    });
  }
  let randomBackground = Math.floor(Math.random() * Math.floor(3)) + 1;
  if (typeof window !== 'undefined') {
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if (viewportWidth <= 1400) {
      randomBackground = 2;
    }
  }

  return (
    <div className={`third-view-body background_${randomBackground}`} id="articles">
      <TitleHeader
        title="Nous partageons avec vous"
        titleColor="#dedee3"
        subtitle="Derniers articles"
        subtitleColor="#4d12c7"
      />
      <div className="post-container">
        {postPreviewDivs}
      </div>
      <div className="footer">
        <ButtonText theme="dark" link="/blog">
          Voir tous les articles
        </ButtonText>
      </div>
    </div>
  );
};

IndexThirdView.defaultProps = {
  data: {},
};

IndexThirdView.propTypes = {
  data: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape({
      pictures: PropTypes.array, title: PropTypes.string, subtitle: PropTypes.string, slug: PropTypes.string,
    })),
  }),
};

export default IndexThirdView;



// WEBPACK FOOTER //
// ./src/components/IndexThirdView/IndexThirdView.jsx